import { useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Icon } from '@iconify/react'
import { Spin, Tag, Tooltip } from 'antd'

import CandidatePfd from './candidate-pfd'
import CandidateForm from './candidate-form'
import StatusModal from './status-modal'
import { CANDIDATE_STATUS } from './candidate-status-tab-list'
import { PRIVATE_ROUTES } from '../../../routes'
import { loginState } from '../../login/login.slice'
import { getTalentAccess } from '../../../helpers/reportsPermission'
import styles from '../candidate.module.css'

const CandidateDetails = () => {
    const [statusModal, setStatusModal] = useState({
        open: false,
        candidate: null,
        status: null,
    })
    const { userProfile } = useSelector(loginState)
    const talentAccess = useMemo(
        () => getTalentAccess(userProfile),
        [userProfile]
    )
    const { isLoading, cnadidateResusmeUrl, candidateDetails, activeTab } =
        useSelector((state) => state.candidateSlice)
    const currentStatus = CANDIDATE_STATUS.find(
        (status) => status.value === candidateDetails?.status
    )
    const isConverted = candidateDetails?.status === 'convertToUser'
    const canChangeStatus = talentAccess.canEdit && !isConverted
    const navigate = useNavigate()

    const openStatusModal = () => {
        if (!canChangeStatus || !candidateDetails) return
        setStatusModal({
            open: true,
            candidate: candidateDetails,
            status: candidateDetails?.status,
        })
    }

    return (
        <div className={styles.detailPage}>
            <Spin spinning={Boolean(isLoading)}>
                <div>
                    <div className={styles.detailHeader}>
                        <div className={styles.detailHeaderLeft}>
                            <Tooltip title="Back">
                                <button
                                    type="button"
                                    className={styles.backBtn}
                                    onClick={() =>
                                        navigate(PRIVATE_ROUTES.candidate.root)
                                    }
                                    aria-label="Back to candidates"
                                >
                                    <Icon
                                        icon="mdi:arrow-left"
                                        width={18}
                                        height={18}
                                    />
                                </button>
                            </Tooltip>
                            <div className={styles.detailHeaderText}>
                                <p className={styles.detailEyebrow}>
                                    Candidate view
                                </p>
                                <p className={styles.detailTitle}>
                                    {candidateDetails?.fullName || 'Candidate'}
                                </p>
                                {candidateDetails?.personalEmail ? (
                                    <p className={styles.detailSubtitle}>
                                        {candidateDetails.personalEmail}
                                    </p>
                                ) : null}
                            </div>
                        </div>

                        <div className={styles.detailHeaderActions}>
                            {currentStatus ? (
                                <Tooltip
                                    title={
                                        canChangeStatus
                                            ? 'Change Status'
                                            : currentStatus.label
                                    }
                                >
                                    <Tag
                                        color={currentStatus.color}
                                        className={`${styles.statusChip} ${
                                            !canChangeStatus
                                                ? styles.statusChipDisabled
                                                : ''
                                        }`}
                                        onClick={openStatusModal}
                                    >
                                        {currentStatus.label}
                                    </Tag>
                                </Tooltip>
                            ) : null}
                        </div>
                    </div>

                    <div className={styles.detailGrid}>
                        <div
                            className={`${styles.detailPane} ${styles.resumePane}`}
                        >
                            <CandidatePfd pdfUrl={cnadidateResusmeUrl} />
                        </div>
                        <div
                            className={`${styles.detailPane} ${styles.formPane}`}
                        >
                            <CandidateForm />
                        </div>
                    </div>
                </div>
            </Spin>

            <StatusModal
                activeStatus={activeTab}
                statusModal={statusModal}
                setStatusModal={setStatusModal}
                open={statusModal.open}
                isDetailsApi={true}
                selectedStatus={statusModal?.status}
                isDetails={statusModal?.candidate?.isCompleteCandidateDetails}
                onClose={() => setStatusModal({ open: false, candidate: null })}
                onChange={(newStatus) =>
                    setStatusModal((prev) => ({
                        ...prev,
                        status: newStatus,
                    }))
                }
            />
        </div>
    )
}

export default CandidateDetails
